(function () {
  'use strict';

  var STAR_TEXT = '\u2605\u2605\u2605\u2605\u2605';
  var STAR_PATH = 'M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z';

  if (window.CustomerReviewsSystem && window.CustomerReviewsSystem.initAll) {
    window.CustomerReviewsSystem.initAll(document);
    return;
  }

  var cache = window.CustomerReviewsCache || {};
  cache.files = cache.files || {};
  window.CustomerReviewsCache = cache;

  function toString(value) {
    return value == null ? '' : String(value);
  }

  function trim(value) {
    return toString(value).trim();
  }

  function toBool(value) {
    return value === true || value === 'true' || value === '1' || value === 'yes';
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizeHeader(value) {
    return trim(value).replace(/^\uFEFF/, '').toLowerCase();
  }

  function normalizeHandle(value) {
    return trim(value).toLowerCase();
  }

  function parseBool(value) {
    var normalized = trim(value).toLowerCase();
    return normalized === 'true' || normalized === 'yes' || normalized === '1';
  }

  function parseRating(value) {
    var rating = parseFloat(trim(value).replace(',', '.'));
    if (!Number.isFinite(rating)) {
      rating = 0;
    }
    return Math.min(5, Math.max(0, rating));
  }

  function parseReviewDate(value) {
    var input = trim(value);
    var match;
    var parsed;

    if (!input) {
      return 0;
    }

    match = input.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+.*)?$/);
    if (match) {
      parsed = Date.UTC(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
      return Number.isFinite(parsed) ? parsed : 0;
    }

    match = input.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s].*)?$/);
    if (match) {
      parsed = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      return Number.isFinite(parsed) ? parsed : 0;
    }

    parsed = Date.parse(input);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function parseCSVRows(text) {
    var source = toString(text).replace(/^\uFEFF/, '');
    var rows = [];
    var row = [];
    var field = '';
    var inQuotes = false;
    var i;
    var char;
    var next;

    function pushField() {
      row.push(field);
      field = '';
    }

    function pushRow() {
      var hasContent = row.some(function (cell) {
        return trim(cell) !== '';
      });

      if (hasContent || row.length > 1) {
        rows.push(row);
      }

      row = [];
    }

    for (i = 0; i < source.length; i += 1) {
      char = source.charAt(i);

      if (inQuotes) {
        if (char === '"') {
          next = source.charAt(i + 1);
          if (next === '"') {
            field += '"';
            i += 1;
          } else {
            inQuotes = false;
          }
        } else {
          field += char;
        }
      } else if (char === '"') {
        inQuotes = true;
      } else if (char === ',') {
        pushField();
      } else if (char === '\n') {
        pushField();
        pushRow();
      } else if (char === '\r') {
        pushField();
        if (source.charAt(i + 1) === '\n') {
          i += 1;
        }
        pushRow();
      } else {
        field += char;
      }
    }

    if (field !== '' || row.length) {
      pushField();
      pushRow();
    }

    return rows;
  }

  function normalizeReview(row, index) {
    return {
      id: trim(row.id),
      product_handle: normalizeHandle(row.product_handle),
      author_name: trim(row.author_name) || 'Anonymous',
      verified: parseBool(row.verified),
      rating: parseRating(row.rating),
      review_text: trim(row.review_text || row.text),
      image_urls: trim(row.image_urls || row.review_image_url).split('|').map(trim).filter(Boolean),
      video_url: trim(row.video_url || row.review_video_url),
      date: trim(row.date),
      date_timestamp: parseReviewDate(row.date),
      item_type: trim(row.item_type),
      translated_from: trim(row.translated_from),
      _index: index
    };
  }

  function parseCSV(text) {
    if (String(text).trim().startsWith('{')) {
      var data = JSON.parse(text);
      if (data.version !== 1 || typeof data.csv !== 'string') throw new Error('Invalid review data.');
      text = data.csv;
    }
    var rows = parseCSVRows(text);
    var headers;
    var reviews = [];

    if (!rows.length) {
      return reviews;
    }

    headers = rows.shift().map(normalizeHeader);

    rows.forEach(function (cells, rowIndex) {
      var row = {};

      headers.forEach(function (header, index) {
        if (!header || row[header] !== undefined) {
          return;
        }
        row[header] = cells[index] == null ? '' : cells[index];
      });

      if (
        trim(row.author_name) ||
        trim(row.review_text || row.text) ||
        trim(row.rating) ||
        trim(row.product_handle)
      ) {
        reviews.push(normalizeReview(row, rowIndex));
      }
    });

    return reviews;
  }

  cache.parseCSV = parseCSV;
  cache.parseDate = parseReviewDate;

  cache.load = function (csvUrl) {
    var url = trim(csvUrl);

    if (!url) {
      return Promise.reject(new Error('Missing customer reviews CSV URL.'));
    }

    if (!cache.files[url]) {
      cache.files[url] = fetch(url, {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Customer reviews CSV could not be loaded.');
          }
          return response.text();
        })
        .then(parseCSV)
        .catch(function (error) {
          delete cache.files[url];
          throw error;
        });
    }

    return cache.files[url];
  };

  cache.filterReviews = function (reviews, options) {
    var settings = options || {};
    var reviewSource = settings.reviewSource || 'current_product';
    var handle = normalizeHandle(settings.productHandleOverride || settings.productHandle);
    var includeGlobal = toBool(settings.includeGlobalReviews);
    var filtered;

    if (reviewSource === 'all_reviews') {
      return sortReviews(reviews);
    }

    if (!handle) {
      return [];
    }

    filtered = reviews.filter(function (review) {
      return review.product_handle === handle || (includeGlobal && !review.product_handle);
    });

    return sortReviews(filtered);
  };

  cache.getSummary = getSummary;

  function sortReviews(reviews) {
    return reviews.slice().sort(function (a, b) {
      if (b.date_timestamp !== a.date_timestamp) {
        return b.date_timestamp - a.date_timestamp;
      }
      return a._index - b._index;
    });
  }

  function getSummary(reviews) {
    var distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var count = reviews.length;
    var total = 0;

    reviews.forEach(function (review) {
      var bucket = Math.round(review.rating);
      total += review.rating;

      if (bucket < 1) {
        bucket = 1;
      }
      if (bucket > 5) {
        bucket = 5;
      }
      distribution[bucket] += 1;
    });

    return {
      count: count,
      average: count ? total / count : 0,
      distribution: distribution
    };
  }

  function removeChildren(node) {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function createElement(tagName, className) {
    var element = document.createElement(tagName);
    if (className) {
      element.className = className;
    }
    return element;
  }

  function createTextElement(tagName, className, text) {
    var element = createElement(tagName, className);
    element.textContent = text;
    return element;
  }

  function reviewsLabel(count) {
    return count + ' ' + (count === 1 ? 'Review' : 'Reviews');
  }

  function reviewsLabelLower(count) {
    return count + ' review' + (count === 1 ? '' : 's');
  }

  function formatAverage(value) {
    return (Math.round(value * 10) / 10).toFixed(1);
  }

  function createStars(rating, className) {
    var wrapper = createElement('span', className || 'customer-reviews-stars');
    var base = createTextElement('span', 'customer-reviews-stars__base', STAR_TEXT);
    var fill = createTextElement('span', 'customer-reviews-stars__fill', STAR_TEXT);
    var percentage = Math.max(0, Math.min(100, (rating / 5) * 100));

    wrapper.setAttribute('role', 'img');
    wrapper.setAttribute('aria-label', formatAverage(rating) + ' out of 5 stars');
    fill.style.width = percentage + '%';
    wrapper.appendChild(base);
    wrapper.appendChild(fill);

    return wrapper;
  }

  function createSvgFromMarkup(markup) {
    var wrapper = document.createElement('span');
    wrapper.innerHTML = markup;
    return wrapper.firstElementChild;
  }

  function createStarSvg(size, filled) {
    var svg = createSvgFromMarkup(
      '<svg class="rc-rc-reviewx" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" aria-hidden="true"><path d="' + STAR_PATH + '"></path></svg>'
    );
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.style.opacity = filled ? '1' : '0.22';
    return svg;
  }

  function appendStarSvgs(parent, rating, size) {
    var rounded = Math.round(rating);
    var i;

    for (i = 1; i <= 5; i += 1) {
      parent.appendChild(createStarSvg(size, i <= rounded));
    }
  }

  function createVerifiedSvg() {
    return createSvgFromMarkup(
      '<svg class="rc-review__verified" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#111111"></circle><path d="M8 12.5l2.6 2.6L16 9.4" stroke="#FFFFFF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg>'
    );
  }

  function safeUrl(value, options) {
    var url = trim(value);
    var lower = url.replace(/\s+/g, '').toLowerCase();
    var settings = options || {};

    if (!url || lower.indexOf('javascript:') === 0 || lower.indexOf('data:') === 0 || lower.indexOf('vbscript:') === 0) {
      return '';
    }

    if (settings.media) {
      if (/^(https?:)?\/\//i.test(url) || url.charAt(0) === '/' || /^(files|cdn|assets)\//i.test(url)) {
        return url;
      }
      return '';
    }

    return url;
  }

  function formatReviewDate(review, format, locale) {
    var fmt = format || 'medium';
    var timestamp = review.date_timestamp;
    var date;
    var options;
    var diffDays;
    var months;
    var years;
    var weeks;

    if (!timestamp || fmt === 'none') {
      return '';
    }

    date = new Date(timestamp);

    if (fmt === 'relative') {
      diffDays = Math.floor((Date.now() - timestamp) / 86400000);
      if (diffDays < 1) {
        return 'Today';
      }
      if (diffDays === 1) {
        return 'Yesterday';
      }
      if (diffDays < 7) {
        return diffDays + ' days ago';
      }
      if (diffDays < 30) {
        weeks = Math.floor(diffDays / 7);
        return weeks + ' week' + (weeks === 1 ? '' : 's') + ' ago';
      }
      if (diffDays < 365) {
        months = Math.floor(diffDays / 30);
        return months + ' month' + (months === 1 ? '' : 's') + ' ago';
      }
      years = Math.floor(diffDays / 365);
      return years + ' year' + (years === 1 ? '' : 's') + ' ago';
    }

    if (fmt === 'short') {
      options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    } else if (fmt === 'long') {
      options = { day: 'numeric', month: 'long', year: 'numeric' };
    } else {
      options = { day: 'numeric', month: 'short', year: 'numeric' };
    }

    try {
      return new Intl.DateTimeFormat(locale || 'en-AU', options).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en-AU', options).format(date);
    }
  }

  function setSectionState(section, state) {
    Array.prototype.slice.call(section.querySelectorAll('[data-rc-state]')).forEach(function (element) {
      element.hidden = element.getAttribute('data-rc-state') !== state;
    });
  }

  function renderDistribution(summary, section) {
    var distribution = section.querySelector('[data-customer-reviews-distribution]');
    var total = summary.count || 1;
    var rating;

    if (!distribution) {
      return;
    }

    removeChildren(distribution);

    for (rating = 5; rating >= 1; rating -= 1) {
      var count = summary.distribution[rating] || 0;
      var row = createElement('div', 'rc-reviews__dist-row');
      var stars = createElement('span', 'rc-reviews__dist-stars');
      var bar = createElement('span', 'rc-reviews__dist-bar');
      var fill = createElement('span', 'rc-reviews__dist-bar-fill');
      var countClass = count === 0 ? 'rc-reviews__dist-count rc-reviews__dist-count--zero' : 'rc-reviews__dist-count';

      stars.setAttribute('aria-label', rating + ' stars');
      appendStarSvgs(stars, rating, 11);
      fill.style.width = Math.round((count / total) * 100) + '%';

      bar.appendChild(fill);
      row.appendChild(stars);
      row.appendChild(bar);
      row.appendChild(createTextElement('span', countClass, '(' + count + ')'));
      distribution.appendChild(row);
    }
  }

  function renderSummary(section, reviews) {
    var summaryElement = section.querySelector('[data-customer-reviews-summary]');
    var settings = section.dataset;
    var summary = getSummary(reviews);
    var avgElement;
    var countElement;
    var writeLink;

    if (!summaryElement || !toBool(settings.showSummary)) {
      if (summaryElement) {
        summaryElement.hidden = true;
      }
      return;
    }

    summaryElement.hidden = false;

    avgElement = section.querySelector('[data-rc-avg]');
    if (avgElement && toBool(settings.showAverageScore)) {
      avgElement.textContent = formatAverage(summary.average);
    }

    countElement = section.querySelector('[data-rc-count]');
    if (countElement && toBool(settings.showReviewCount)) {
      countElement.textContent = reviewsLabelLower(summary.count);
    }

    if (toBool(settings.showDistribution)) {
      renderDistribution(summary, section);
    }

    writeLink = summaryElement.querySelector('.rc-reviews__actions a');
    if (writeLink) {
      writeLink.href = safeUrl(settings.writeReviewUrl || '#customer-reviews') || '#customer-reviews';
    }
  }

  function createReviewMedia(review) {
    var images = review.image_urls || [];
    var videoUrl = safeUrl(review.video_url, { media: true });
    var imageUrl = images.length ? safeUrl(images[0], { media: true }) : '';
    var media;

    if (videoUrl) {
      var video = document.createElement('video');
      video.src = videoUrl;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.setAttribute('aria-label', 'Review video');

      media = createElement('div', 'rc-review__media');
      media.appendChild(video);
      media.appendChild(createSvgFromMarkup(
        '<div class="rc-review__video-overlay"><div class="rc-review__video-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="6 4 20 12 6 20"></polygon></svg></div></div>'
      ));
      return media;
    }

    if (!imageUrl) {
      return null;
    }

    var image = document.createElement('img');
    image.src = imageUrl;
    image.alt = '';
    image.loading = 'lazy';

    media = createElement('div', 'rc-review__media');
    media.appendChild(image);

    if (images.length > 1) {
      var badge = createElement('div', 'rc-review__multi-badge');
      badge.appendChild(createSvgFromMarkup(
        '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><rect x="3" y="3" width="14" height="14" rx="2"></rect><rect x="7" y="7" width="14" height="14" rx="2"></rect></svg>'
      ));
      badge.appendChild(document.createTextNode('+' + (images.length - 1)));
      media.appendChild(badge);
    }

    return media;
  }

  function createReviewCard(review, section) {
    var settings = section.dataset;
    var card = createElement('article', 'rc-review');
    var body = createElement('div', 'rc-review__body');
    var authorRow = createElement('div', 'rc-review__author-row');
    var author = createElement('span', 'rc-review__author');
    var authorName = createTextElement('span', 'rc-review__author-name', review.author_name || 'Anonymous');
    var stars = createElement('div', 'rc-review__stars');
    var dateLabel = formatReviewDate(review, settings.dateFormat, settings.dateLocale);
    var media;
    var metaParts = [];
    var meta;

    card.setAttribute('aria-label', formatAverage(review.rating) + ' out of 5 stars review by ' + (review.author_name || 'Anonymous'));

    if (toBool(settings.showMedia)) {
      media = createReviewMedia(review);
      if (media) {
        card.appendChild(media);
      }
    }

    author.appendChild(authorName);
    if (review.verified && toBool(settings.showVerifiedBadge)) {
      author.appendChild(createVerifiedSvg());
    }

    authorRow.appendChild(author);

    if (dateLabel) {
      authorRow.appendChild(createTextElement('span', 'rc-review__date', dateLabel));
    }

    stars.setAttribute('aria-label', formatAverage(review.rating) + ' out of 5 stars');
    appendStarSvgs(stars, review.rating, toNumber(getComputedStyle(section).getPropertyValue('--rc-card-star-size'), 18));

    body.appendChild(authorRow);
    body.appendChild(stars);

    if (review.review_text) {
      body.appendChild(createTextElement('p', 'rc-review__text', review.review_text));
    }

    if (review.item_type && toBool(settings.showItemType)) {
      var itemType = createElement('div');
      itemType.appendChild(createTextElement('span', 'rc-review__meta-label', 'Item type'));
      itemType.appendChild(document.createTextNode(review.item_type));
      metaParts.push(itemType);
    }

    if (review.translated_from && toBool(settings.showTranslatedFrom)) {
      metaParts.push(createTextElement('div', 'rc-review__translated', 'Auto-translated from ' + review.translated_from + '.'));
    }

    if (metaParts.length) {
      meta = createElement('div', 'rc-review__meta');
      metaParts.forEach(function (part) {
        meta.appendChild(part);
      });
      body.appendChild(meta);
    }

    card.appendChild(body);
    return card;
  }

  function renderCards(section, state) {
    var list = section.querySelector('[data-customer-reviews-list]');
    var button = section.querySelector('[data-customer-reviews-load-more]');
    var moreWrap = section.querySelector('[data-rc-more-wrap]');
    var visibleReviews = state.reviews.slice(0, state.visibleCount);

    if (!list) {
      return;
    }

    removeChildren(list);
    visibleReviews.forEach(function (review) {
      list.appendChild(createReviewCard(review, section));
    });

    list.hidden = false;

    if (button && moreWrap) {
      moreWrap.hidden = state.visibleCount >= state.reviews.length;
      button.textContent = 'Show more reviews';
      button.setAttribute('aria-label', 'Show more customer reviews');
    }
  }

  function renderSection(section, state) {
    var list = section.querySelector('[data-customer-reviews-list]');
    var moreWrap = section.querySelector('[data-rc-more-wrap]');
    var summary = section.querySelector('[data-customer-reviews-summary]');

    if (!state.reviews.length) {
      if (list) {
        removeChildren(list);
        list.hidden = true;
      }
      if (moreWrap) {
        moreWrap.hidden = true;
      }
      if (summary) {
        summary.hidden = true;
      }
      setSectionState(section, 'empty');
      return;
    }

    setSectionState(section, '');
    renderSummary(section, state.reviews);
    renderCards(section, state);
  }

  function initReviewSection(section) {
    var state;
    var button;

    if (section.dataset.customerReviewsInitialized === 'true') {
      return;
    }

    section.dataset.customerReviewsInitialized = 'true';
    initReviewForm(section);

    state = {
      reviews: [],
      visibleCount: Math.max(1, toNumber(section.dataset.initialCount, 12))
    };

    button = section.querySelector('[data-customer-reviews-load-more]');
    if (button) {
      button.addEventListener('click', function () {
        state.visibleCount += Math.max(1, toNumber(section.dataset.loadMoreCount, 12));
        renderCards(section, state);
      });
    }

    setSectionState(section, 'loading');

    cache.load(section.dataset.csvUrl)
      .then(function (reviews) {
        state.reviews = cache.filterReviews(reviews, {
          reviewSource: section.dataset.reviewSource,
          productHandle: section.dataset.productHandle,
          productHandleOverride: section.dataset.productHandleOverride,
          includeGlobalReviews: section.dataset.includeGlobalReviews
        });
        renderSection(section, state);
      })
      .catch(function (error) {
        var moreWrap = section.querySelector('[data-rc-more-wrap]');
        if (moreWrap) {
          moreWrap.hidden = true;
        }
        if (window.console && console.error) {
          console.error('[Customer reviews]', error);
        }
        setSectionState(section, 'error');
      });
  }

  function initReviewForm(section) {
    var modal = section.querySelector('[data-rc-modal]');
    var openButton = section.querySelector('[data-rc-open-form]');
    var form;
    var currentRating = 0;

    if (!modal || modal.dataset.customerReviewsFormInitialized === 'true') {
      return;
    }

    modal.dataset.customerReviewsFormInitialized = 'true';
    form = modal.querySelector('[data-rc-form]');

    function openModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('rc-modal-open');
      window.setTimeout(function () {
        var firstInput = modal.querySelector('input:not([type="hidden"]):not(.rc-honeypot), textarea, button');
        if (firstInput) {
          firstInput.focus();
        }
      }, 50);
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('rc-modal-open');
    }

    function showError(message) {
      var error = modal.querySelector('[data-rc-form-error]');
      if (!error) {
        return;
      }
      error.textContent = message;
      error.hidden = false;
    }

    function clearError() {
      var error = modal.querySelector('[data-rc-form-error]');
      if (!error) {
        return;
      }
      error.textContent = '';
      error.hidden = true;
    }

    function paintStars(value) {
      Array.prototype.slice.call(modal.querySelectorAll('[data-rc-rating-value]')).forEach(function (button) {
        var active = Number(button.dataset.rcRatingValue) <= value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', Number(button.dataset.rcRatingValue) === value ? 'true' : 'false');
      });
    }

    function setRating(value) {
      var hidden = modal.querySelector('[data-rc-rating-hidden]');
      currentRating = value;
      if (hidden) {
        hidden.value = value;
      }
      paintStars(value);
    }

    function clearImage() {
      var input = modal.querySelector('[data-rc-image-input]');
      var hidden = modal.querySelector('[data-rc-image-hidden]');
      var preview = modal.querySelector('[data-rc-upload-preview]');
      var image = modal.querySelector('[data-rc-upload-img]');
      var cta = modal.querySelector('[data-rc-upload-cta]');

      if (input) {
        input.value = '';
      }
      if (hidden) {
        hidden.value = '';
      }
      if (image) {
        image.removeAttribute('src');
        image.alt = '';
      }
      if (preview) {
        preview.hidden = true;
      }
      if (cta) {
        cta.hidden = false;
      }
    }

    function resizeImage(file, maxDim) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onerror = reject;
        reader.onload = function () {
          var image = new Image();

          image.onerror = reject;
          image.onload = function () {
            var width = image.width;
            var height = image.height;
            var canvas;
            var context;

            if (width > maxDim || height > maxDim) {
              if (width > height) {
                height = Math.round(height * (maxDim / width));
                width = maxDim;
              } else {
                width = Math.round(width * (maxDim / height));
                height = maxDim;
              }
            }

            canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, width, height);
            resolve(canvas.toDataURL('image/jpeg', 0.82));
          };

          image.src = reader.result;
        };

        reader.readAsDataURL(file);
      });
    }

    function handleImageUpload(event) {
      var file = event.target.files && event.target.files[0];
      var maxDim = Math.max(600, toNumber(section.dataset.formImageMax, 1000));

      if (!file) {
        clearImage();
        return;
      }

      if (!file.type || file.type.indexOf('image/') !== 0) {
        showError("That does not look like an image. Try a JPG or PNG.");
        clearImage();
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        showError('Image is over 10MB. Pick a smaller file.');
        clearImage();
        return;
      }

      resizeImage(file, maxDim)
        .then(function (dataUrl) {
          var hidden = modal.querySelector('[data-rc-image-hidden]');
          var preview = modal.querySelector('[data-rc-upload-preview]');
          var image = modal.querySelector('[data-rc-upload-img]');
          var cta = modal.querySelector('[data-rc-upload-cta]');

          if (hidden) {
            hidden.value = dataUrl;
          }
          if (image) {
            image.src = dataUrl;
            image.alt = 'Uploaded review photo preview';
          }
          if (preview) {
            preview.hidden = false;
          }
          if (cta) {
            cta.hidden = true;
          }
          clearError();
        })
        .catch(function () {
          showError("Could not process that image. Try another one.");
          clearImage();
        });
    }

    function showSuccess() {
      var formBody = modal.querySelector('[data-rc-form-body]');
      var successPanel = modal.querySelector('[data-rc-form-success]');
      var submit = modal.querySelector('[data-rc-submit]');
      var submitLabel = modal.querySelector('[data-rc-submit-label]');

      if (formBody) {
        formBody.hidden = true;
      }
      if (successPanel) {
        successPanel.hidden = false;
      }
      if (form) {
        form.reset();
      }
      currentRating = 0;
      paintStars(0);
      clearImage();
      if (submit) {
        submit.disabled = false;
      }
      if (submitLabel) {
        submitLabel.textContent = 'Submit review';
      }
    }

    function submitToShopifyContact() {
      var formData = new FormData(form);
      var name = (form.querySelector('[data-rc-name]') || {}).value || '';
      var email = (form.querySelector('[data-rc-email]') || {}).value || '';
      var reviewText = (form.querySelector('[data-rc-review-text]') || {}).value || '';
      var productHandle = (form.querySelector('input[name="contact[product_handle]"]') || {}).value || '';
      var imageData = (form.querySelector('[data-rc-image-hidden]') || {}).value || '';
      var action = form.getAttribute('action') || '/contact';

      formData.set('form_type', 'contact');
      formData.set('utf8', '\u2713');
      formData.set('contact[email]', email);
      formData.set('contact[name]', name);
      formData.set('contact[subject]', 'New review submission - Customer reviews');
      formData.set('contact[body]', [
        'New review submission',
        '',
        'Name: ' + name,
        'Email: ' + email,
        'Rating: ' + currentRating + ' / 5',
        productHandle ? 'Product handle: ' + productHandle : '',
        '',
        'Review:',
        reviewText,
        '',
        imageData ? 'Photo selected: yes. Use webhook destination if photo intake is required.' : 'Photo selected: no.'
      ].filter(Boolean).join('\n'));
      formData.delete('contact[image_data_url]');

      return fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Contact form failed: ' + response.status);
        }
        return response.text();
      });
    }

    function submitToWebhook() {
      var webhookUrl = trim(section.dataset.formWebhookUrl);
      var payload;

      if (!webhookUrl) {
        return Promise.reject(new Error('Missing webhook URL.'));
      }

      payload = {
        name: (form.querySelector('[data-rc-name]') || {}).value || '',
        email: (form.querySelector('[data-rc-email]') || {}).value || '',
        rating: currentRating,
        review_text: (form.querySelector('[data-rc-review-text]') || {}).value || '',
        image_data_url: (form.querySelector('[data-rc-image-hidden]') || {}).value || '',
        product_handle: (form.querySelector('input[name="contact[product_handle]"]') || {}).value || '',
        submitted_at: new Date().toISOString()
      };

      return fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Webhook failed: ' + response.status);
        }
        return response.text();
      });
    }

    function handleSubmit(event) {
      var submit = modal.querySelector('[data-rc-submit]');
      var submitLabel = modal.querySelector('[data-rc-submit-label]');
      var emailInput = form.querySelector('[data-rc-email]');
      var reviewInput = form.querySelector('[data-rc-review-text]');
      var honeypot = form.querySelector('.rc-honeypot');
      var minLength = toNumber(section.dataset.formMinLength, 0);
      var destination = section.dataset.formDestination || 'shopify_contact';
      var submitPromise;

      event.preventDefault();
      clearError();

      if (honeypot && honeypot.value) {
        showSuccess();
        return;
      }

      if (!currentRating || currentRating < 1) {
        showError('Pick a rating before submitting.');
        return;
      }

      if (emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
        showError('Enter a valid email before submitting.');
        emailInput.focus();
        return;
      }

      if (reviewInput && reviewInput.value.trim().length < minLength) {
        showError('Review needs at least ' + minLength + ' characters.');
        reviewInput.focus();
        return;
      }

      if (submit) {
        submit.disabled = true;
      }
      if (submitLabel) {
        submitLabel.textContent = 'Submitting...';
      }

      submitPromise = destination === 'webhook' ? submitToWebhook() : submitToShopifyContact();
      submitPromise
        .then(showSuccess)
        .catch(function (error) {
          if (window.console && console.error) {
            console.error('[Customer reviews]', error);
          }
          showError("Could not submit your review. Please try again.");
          if (submit) {
            submit.disabled = false;
          }
          if (submitLabel) {
            submitLabel.textContent = 'Submit review';
          }
        });
    }

    if (openButton) {
      openButton.addEventListener('click', openModal);
    }

    Array.prototype.slice.call(modal.querySelectorAll('[data-rc-close]')).forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.classList.contains('rc-modal__overlay')) {
        closeModal();
      }
    });

    Array.prototype.slice.call(modal.querySelectorAll('[data-rc-rating-value]')).forEach(function (button) {
      button.addEventListener('click', function () {
        setRating(Number(button.dataset.rcRatingValue));
      });
      button.addEventListener('mouseenter', function () {
        paintStars(Number(button.dataset.rcRatingValue));
      });
    });

    var ratingInput = modal.querySelector('[data-rc-rating-input]');
    if (ratingInput) {
      ratingInput.addEventListener('mouseleave', function () {
        paintStars(currentRating);
      });
    }

    var imageInput = modal.querySelector('[data-rc-image-input]');
    if (imageInput) {
      imageInput.addEventListener('change', handleImageUpload);
    }

    var imageRemove = modal.querySelector('[data-rc-upload-remove]');
    if (imageRemove) {
      imageRemove.addEventListener('click', clearImage);
    }

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    document.addEventListener('keydown', function (event) {
      if (!modal.hidden && event.key === 'Escape') {
        closeModal();
      }
    });
  }

  function getScrollTarget(selector) {
    var targetSelector = trim(selector || '#customer-reviews');

    if (!targetSelector) {
      return null;
    }

    try {
      return document.querySelector(targetSelector);
    } catch (error) {
      return document.getElementById(targetSelector.replace(/^#/, ''));
    }
  }

  function renderRatingBlock(block, summary) {
    var content = block.querySelector('[data-customer-reviews-rating-content]');
    var displayStyle = block.dataset.displayStyle || 'stars_count';
    var showWhenEmpty = toBool(block.dataset.showWhenEmpty);
    var emptyText = block.dataset.emptyText || 'No reviews yet';
    var averageText = formatAverage(summary.average);

    if (!content) {
      return;
    }

    removeChildren(content);

    if (!summary.count) {
      if (!showWhenEmpty) {
        block.hidden = true;
        return;
      }
      content.textContent = emptyText;
      content.setAttribute('aria-label', emptyText);
      block.hidden = false;
      return;
    }

    var stars = createElement('span', 'customer-reviews-rating__svg-stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', averageText + ' out of 5 stars');
    appendStarSvgs(stars, summary.average, toNumber(getComputedStyle(block).getPropertyValue('--cr-rating-star-size'), 14));
    content.appendChild(stars);

    if (displayStyle === 'stars_average_count') {
      content.appendChild(createTextElement('span', 'customer-reviews-rating__average', averageText));
      content.appendChild(createTextElement('span', 'customer-reviews-rating__divider', '|'));
    }

    content.appendChild(createTextElement('span', 'customer-reviews-rating__count', reviewsLabel(summary.count)));
    content.setAttribute('aria-label', 'Average rating ' + averageText + ' out of 5, ' + reviewsLabel(summary.count));
    block.hidden = false;
  }

  function initRatingBlock(block) {
    var content;

    if (block.dataset.customerReviewsRatingInitialized === 'true') {
      return;
    }

    block.dataset.customerReviewsRatingInitialized = 'true';
    content = block.querySelector('[data-customer-reviews-rating-content]');

    if (content && toBool(block.dataset.clickScroll)) {
      content.addEventListener('click', function () {
        var target = getScrollTarget(block.dataset.scrollTarget);
        if (target) {
          lazySections.forEach(function (_, section) { if (target.contains(section) || section.contains(target)) activate(section); });
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.pushState && target.id) {
            history.pushState(null, '', '#' + target.id);
          }
        }
      });
    }

    if (block.dataset.summaryCount !== undefined) {
      renderRatingBlock(block, { count: Number(block.dataset.summaryCount), average: Number(block.dataset.summaryAverage) });
      return;
    }

    cache.load(block.dataset.csvUrl)
      .then(function (reviews) {
        var filtered = cache.filterReviews(reviews, {
          reviewSource: 'current_product',
          productHandle: block.dataset.productHandle,
          includeGlobalReviews: false
        });
        renderRatingBlock(block, getSummary(filtered));
      })
      .catch(function () {
        renderRatingBlock(block, getSummary([]));
      });
  }

  var lazySections = new Map();
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) activate(entry.target);
    });
  }, { rootMargin: '400px' }) : null;
  function activate(section) {
    var init = lazySections.get(section);
    if (!init) return;
    lazySections.delete(section);
    if (observer) observer.unobserve(section);
    init(section);
  }
  function nearViewport(section, init) {
    lazySections.set(section, init);
    if (!observer || window.Shopify?.designMode || (location.hash && section.querySelector(':scope ' + '[id="' + CSS.escape(location.hash.slice(1)) + '"]')) || section.id === location.hash.slice(1)) activate(section);
    else observer.observe(section);
  }
  cache.nearViewport = nearViewport;
  function activateHash() {
    if (!location.hash) return;
    var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    lazySections.forEach(function (_, section) { if (target && (section.contains(target) || target.contains(section))) activate(section); });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (link) { var target = document.getElementById(link.hash.slice(1)); lazySections.forEach(function (_, section) { if (target && (target.contains(section) || section.contains(target))) activate(section); }); }
  });
  window.addEventListener('hashchange', activateHash);
  document.addEventListener('shopify:section:unload', function (event) {
    lazySections.forEach(function (_, section) { if (event.target.contains(section)) { lazySections.delete(section); observer?.unobserve(section); } });
  });

  function initAll(scope) {
    var root = scope || document;
    var sections;
    var ratingBlocks;

    if (!root.querySelectorAll) {
      return;
    }

    sections = root.matches && root.matches('[data-customer-reviews-section]')
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('[data-customer-reviews-section]'));

    ratingBlocks = root.matches && root.matches('[data-customer-reviews-rating]')
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('[data-customer-reviews-rating]'));

    sections.forEach(function (section) { nearViewport(section, initReviewSection); });
    ratingBlocks.forEach(initRatingBlock);
  }

  window.CustomerReviewsSystem = {
    initAll: initAll,
    initReviewSection: initReviewSection,
    initRatingBlock: initRatingBlock
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.slice.call(event.target.querySelectorAll('[data-rc-modal]')).forEach(function (modal) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('rc-modal-open');
  });
}());
